<div fxLayout="row" fxLayoutAlign="space-around center">
  <div class="box page-box">
    <div fxLayout="column" fxLayoutAlign="space-around center">
      <div class="prompt-icon">
        <i class="icon icon-small_solid_warning"></i>
      </div>
      <div class="title">
        <h5>{{ 'LOGIN.ACCESS_DENIED' | translate }}</h5>
      </div>
      <div class="message mt-5">
        <div>{{ 'LOGIN.ACCESS_DENIED_MESSAGE' | translate }}</div>
      </div>
    </div>
  </div>
</div>

